
export default {
  install(Vue, options) {
    /* 合法uri*/
    Vue.prototype.validateURL = function (rule, value, callback) {
      setTimeout(() => {
        if (!value) {
          callback(new Error('输入不可以为空'));
        } else {
          const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
          const rsCheck = urlregex.test(value);
          if (!rsCheck) {
            callback(new Error('输入格式有误'));
          } else {
            callback();
          }
        }
      }, 300);
    }
    /* 验证是否整数*/
    Vue.prototype.validateInteger = function (rule, value, callback) {
      if (!value) {
        return callback(new Error('输入不可以为空'));
      }
      setTimeout(() => {
        if (!Number(value)) {
          callback(new Error('请输入正整数'));
        } else {
          const re = /^[0-9]*[1-9][0-9]*$/;
          const rsCheck = re.test(value);
          if (!rsCheck) {
            callback(new Error('请输入正整数'));
          } else {
            callback();
          }
        }
      }, 300);
    }
    /* 验证userid*/
    Vue.prototype.validateUid = function (rule, value, callback) {
      if (!value) {
        return callback(new Error('输入不可以为空'));
      }
      setTimeout(() => {
        const uidregex = new RegExp(/^[A-Za-z0-9_]+$/, "g");
        const rsCheck = uidregex.test(value);
        if (!rsCheck) {
          callback(new Error('请输入英文及数字'));
        } else {
          callback();
        }
      }, 300);
    }
    /* 过滤特殊SQL符号*/
    Vue.prototype.validateSql = function (rule, value, callback) {
      setTimeout(() => {
        const Sqlregex = new RegExp(/^((?!select|update|delete|truncate|insert|drop|exec|’|'|"|;|\/|\\|>|<|!|@|#|%|！|￥|\*).)*$/, "g");
        const rsCheck = Sqlregex.test(value);
        if (!rsCheck) {
          callback(new Error('输入格式有误'));
        } else {
          callback();
        }
      }, 300);
    }
    /* 过滤手机*/
    Vue.prototype.validatePhone = function (rule, value, callback) {
      setTimeout(() => {
        const phoneregex = new RegExp(/^^((13[0-9])|(14[5-9])|(15([0-3]|[5-9]))|(16[6-7])|(17[1-8])|(18[0-9])|(19[1|3])|(19[5|6])|(19[8|9]))\d{8}$/, "g");
        const rsCheck = phoneregex.test(value);
        if (!rsCheck) {
          callback(new Error('输入格式有误'));
        } else {
          callback();
        }
      }, 300);
    }
    /* 验证是否是[0-1]的小数*/
    Vue.prototype.isDecimal = function (rule, value, callback) {
      if (!value) {
        return callback(new Error('输入不可以为空'));
      }
      setTimeout(() => {
        if (!Number(value)) {
          callback(new Error('请输入数字'));
        } else {
          if (value < 0 || value > 1) {
            callback(new Error('请输入[0,1]之间的数字'));
          } else {
            callback();
          }
        }
      }, 300);
    }
    /* 验证端口是否在[0,65535]之间*/
    Vue.prototype.isPort = function (rule, value, callback) {
      if (!value) {
        return callback(new Error('输入不可以为空'));
      }
      setTimeout(() => {
        if (!Number(value)) {
          callback(new Error('请输入数字'));
        } else {
          if (value < 0 || value > 1) {
            callback(new Error('请输入[0,1]之间的数字'));
          } else {
            callback();
          }
        }
      }, 300);
    }
    /* 小写字母*/
    Vue.prototype.validateLowerCase = function (rule, value, callback) {
      setTimeout(() => {
        const reg = /^[a-z]+$/;
        const rsCheck = reg.test(value);
        if (!rsCheck) {
          callback(new Error('输入格式有误'));
        } else {
          callback();
        }
      }, 300);
    }
    /*验证IP*/
    Vue.prototype.validateIP = function (rule, value, callback) {
      setTimeout(() => {
        const reg = /((?:(?:25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(?:25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d))))/;
        if (reg.test(value)) {
          return callback(new Error('请输入正确的ip'))
        } else {
          callback()
        }
      }, 300);
    }
    /*验证数字和特殊符号*/
    Vue.prototype.validateNum = function (rule, value, callback) {
      setTimeout(() => {
        const reg = /[^\d\.-]/g;
        if (reg.test(value)) {
          return callback(new Error('仅支持数字和特殊符号：. -'))
        } else {
          callback()
        }
      }, 300);
    }
    /*验证空白*/
    Vue.prototype.validateEmpty = function (rule, value, callback) {
      if (!value) {
        return callback(new Error('输入不可以为空'));
      }
      else {
        callback()
      }
    }
    /*时间戳转换成日期格式*/
    Vue.prototype.getDate = function (value, format) {
      if (value == "" || value == null || value == "undefine") { return '' }
      const re = /^[0-9]*[1-9][0-9]*$/;
      const rsCheck = re.test(value);
      if (rsCheck) {
        value = value;
      } else {
        let reg = /[\u4e00-\u9fa5]/g;
        value = value.replace(reg, "");
      }
      let date = value !== '' ? new Date(value) : new Date();
      let y = date.getFullYear();
      /*在日期格式中，月份从0开始*/
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;

      let result = '';
      switch (format) {
        case "yyyy-MM-dd": result = y + "-" + MM + "-" + d; break;
        case "yyyy-MM-dd HH:mm:ss": result = y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; break;
        case "yyyy/MM/dd HH:mm:ss": result = y + "/" + MM + "/" + d + " " + h + ":" + m + ":" + s; break;
        case "yyyy/MM/dd": result = y + "/" + MM + "/" + d; break;
        case "yyyy/MM/dd ~ yyyy/MM/dd": result = y + "/" + MM + "/" + d + " ~ " + y + "/" + MM + "/" + new Date(y, MM, 0).getDate(); break;
        case "yyyyMM": result = y + MM;
      }
      return result;
    }
    Vue.prototype.getDateCn = function (value, format) {
      if (value == "" || value == null || value == "undefine") { return '' }

      let time = this.getDate(value, "yyyy-MM-dd HH:mm:ss");
      let date = time !== '' ? new Date(time) : new Date();
      let y = date.getFullYear();
      /*在日期格式中，月份从0开始*/
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;

      if (value.indexOf("上午") > -1) {
        h = (parseInt(h) % 12) < 10 ? "0" + (parseInt(h) % 12) : (parseInt(h) % 12);
      } else if (value.indexOf("下午") > -1) {
        h = parseInt(h) == 12 ? parseInt(h) : parseInt(h) + 12;
      }

      let result = '';
      switch (format) {
        case "yyyy-MM-dd": result = y + "-" + MM + "-" + d; break;
        case "yyyy-MM-dd HH:mm:ss": result = y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; break;
        case "yyyy/MM/dd HH:mm:ss": result = y + "/" + MM + "/" + d + " " + h + ":" + m + ":" + s; break;
        case "yyyy/MM/dd": result = y + "/" + MM + "/" + d; break;
        case "yyyy/MM/dd ~ yyyy/MM/dd": result = y + "/" + MM + "/" + d + " ~ " + y + "/" + MM + "/" + new Date(y, MM, 0).getDate(); break;
        case "yyyyMM": result = y + MM;
      }
      return result;
    }
    Vue.prototype.getPreMonthDate = function (value) {
      if (value == NaN) { value = 0 }

      var date = new Date;
      var year = date.getFullYear();
      var month = date.getMonth() - value;
      if (month == 0) {
        year = year - 1;
        month = 12;
      }
      var month_;
      if (month < 10) {
        month_ = "0" + month.toString();
      }
      else {
        month_ = month.toString();
      }

      return year.toString() + month_.toString()
    }
    //成功讯息手动关闭
    Vue.prototype.mymessage = function (dom, content, duration, onClose) {
      let _remove;
      let h = dom.$createElement;
      //创建VNode
      //定义文本内容及样式（这里的样式延用的官方的）
      const innerText = h('span', { style: { color: '#4a5970', fontSize: '14px' } }, content);
      const innerIcon = h('a-icon', {
        style: { marginLeft: '10px', color: '#cc', cursor: 'pointer' },
        attrs: { type: 'close' },
        on: { click: () => _remove() },
      })
      const container = h('span', {}, [innerText, innerIcon]);

      _remove = dom.$message.success({
        content: container,
        duration: duration || 0,
        onClose: onClose,
      })
    }

  }
}




// WEBPACK FOOTER //
// ./src/js/common.js